import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React, { Component } from 'react'
import { is, Map } from 'immutable'
import { injectIntl } from 'react-intl'
import { Link } from 'react-router'
import withPartials from 'react-component-with-partials'
import messages from '@driftt/translations/messages'
import InputWithLimit from 'components/Customize/InputWithLimit'
import { Subsection } from 'components/settings/UserProfile/Section'
import { makeDefaultFailedContainer } from 'components/container'
import { makeHasGate } from 'app/modules/gates/selectors'
import styles from './styles.styl'

class MessagingInfo extends Component {
  static propTypes = {
    welcomeMessage: PropTypes.string.isRequired,
    awayMessage: PropTypes.string.isRequired
  }

  state = {
    valid: Map()
  }

  renderDeprecated() {
    const { intl, partial, messagingUI, orgSettings } = this.props
    const { welcomeMessage: welcomeMessagePlaceholder, awayMessage: awayMessagePlaceholder } = orgSettings.theme
    return (
      <Subsection title="Welcome Message"
                  isValid={this.isValid()}
                  canSubmit={this.canSubmit()}
                  onSubmit={this.handleSave}
                  onCancel={this.handleCancel}

      >
        <div style={{ width: "100%" }}>
          <div className="color-navy-dark dsg-Body">You can customize the welcome message that appears on your profile page. These messages will respect the <Link to="/settings/widget/hours-and-targeting">online hours</Link> set by your company.</div>
          <div className={styles.MessagingInfo}>
            <div className="flex-1" style={{ marginRight: "4rem" }}>
              <InputWithLimit
                  title="Online message"
                  text={messagingUI.welcomeMessage || ""}
                  isTextAreaAutosize={false}
                  isTextArea={true}
                  placeholder={welcomeMessagePlaceholder || intl.formatMessage(messages.welcomeMessage)}
                  maxLength={164}
                  invalidLabel="You have entered too many characters"
                  onChange={partial(this.handleChange, 'welcomeMessage')}
                  className={styles.WelcomeMessage}
              />
            </div>
            <div className="flex-1">
              <InputWithLimit
                  title="Offline message"
                  text={messagingUI.awayMessage}
                  placeholder={awayMessagePlaceholder || intl.formatMessage(messages.defaultAwayMessageCopy)}
                  isTextAreaAutosize={false}
                  isTextArea={true}
                  maxLength={164}
                  invalidLabel="You have entered too many characters"
                  onChange={partial(this.handleChange, 'awayMessage')}
                  className={styles.WelcomeMessage}
              />
            </div>
          </div>
        </div>
      </Subsection>
    )
  }

  renderNew() {
    const { intl, partial, messagingUI, orgSettings } = this.props
    const { welcomeMessage: welcomeMessagePlaceholder, awayMessage: awayMessagePlaceholder } = orgSettings.theme
    return (
      <Subsection title="Your default greeting"
                  isValid={this.isValid()}
                  canSubmit={this.canSubmit()}
                  onSubmit={this.handleSave}
                  onCancel={this.handleCancel}

      >
        <div style={{ width: "100%" }}>
          <div className="color-navy-dark dsg-Body">Customize how you greet visitors when they start a conversation from the widget on your Drift Profile</div>
          <div className={styles.MessagingInfo}>
            <div className="flex-1" style={{ marginRight: "4rem" }}>
              <InputWithLimit
                  title="Online message"
                  text={messagingUI.welcomeMessage || ""}
                  isTextAreaAutosize={false}
                  isTextArea={true}
                  placeholder={welcomeMessagePlaceholder || intl.formatMessage(messages.welcomeMessage)}
                  maxLength={164}
                  invalidLabel="You have entered too many characters"
                  onChange={partial(this.handleChange, 'welcomeMessage')}
                  className={styles.WelcomeMessage}
              />
            </div>
            <div className="flex-1">
              <InputWithLimit
                  title="Offline message"
                  text={messagingUI.awayMessage}
                  placeholder={awayMessagePlaceholder || intl.formatMessage(messages.defaultAwayMessageCopy)}
                  isTextAreaAutosize={false}
                  isTextArea={true}
                  maxLength={164}
                  invalidLabel="You have entered too many characters"
                  onChange={partial(this.handleChange, 'awayMessage')}
                  className={styles.WelcomeMessage}
              />
            </div>
          </div>
        </div>
      </Subsection>
    )
  }

  render() {
    const {
      hasConsolidatedWelcomeMsg,
    } = this.props

    if (hasConsolidatedWelcomeMsg) {
      return this.renderNew()
    } else {
      return this.renderDeprecated()
    }
  }

  handleChange = (key, value, isValid) => {
    const valid = this.state.valid.set(key, isValid)
    this.setState({ valid })
    this.props.actions.setProfileUIData({ key, value })
  }

  handleSave = () => {
    if (!this.canSubmit()) return

    this.props.actions.updateMessaging()
  }

  handleCancel = () => {
    this.props.actions.setProfileUI(this.props.messaging)
  }

  canSubmit() {
    return !is(this.props.messagingUI, this.props.messaging)
  }

  isValid() {
    return this.state.valid.every(value => !!value)
  }
}

const mapStateToProps = state => ({
  hasConsolidatedWelcomeMsg: makeHasGate('has_consolidated_welcome_msg')(state),
})

export default makeDefaultFailedContainer(withPartials(injectIntl(connect(mapStateToProps)(MessagingInfo))), {
  listenTo: ['stores.OrgSettingsStore', 'stores.DefaultEmbedStore'],
  fetch: {
    orgSettings() {
      return this.app.stores.OrgSettingsStore.getOrgSettings()
    },
  }
})



// WEBPACK FOOTER //
// ./src/scripts/components/settings/UserProfile/Sections/Profile/MessagingInfo/index.js